import { render } from "./Libellula.vue?vue&type=template&id=3732166a"
import script from "./Libellula.vue?vue&type=script&lang=js"
export * from "./Libellula.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__